import api from "../store/services/api";

// Ingredients
export const getIngredients = async (params) =>
  await api.get("/inventory/ingredients/", { params });

export const createIngredient = async (data) =>
  await api.post("/inventory/ingredients/", data, {
    headers: { "Content-Type": "application/json" },
  });

export const updateIngredient = async (id, data) =>
  await api.put(`/inventory/ingredients/${id}/`, data, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteIngredient = async (id) =>
  await api.delete(`/inventory/ingredients/${id}/`);

export const getLowStockIngredients = async () =>
  await api.get("/inventory/ingredients/low_stock/");

// Stock Movements
export const getStockMovements = async (params) =>
  await api.get("/inventory/stock/movements/", { params });

// Stock Entry (purchase)
export const createStockEntry = async (data) =>
  await api.post("/inventory/stock/entry/", data, {
    headers: { "Content-Type": "application/json" },
  });

// Stock Adjustment (manual / loss)
export const createStockAdjustment = async (data) =>
  await api.post("/inventory/stock/adjustment/", data, {
    headers: { "Content-Type": "application/json" },
  });

// Stock Summary (dashboard)
export const getStockSummary = async () =>
  await api.get("/inventory/stock/summary/");

// Recipes
export const getRecipeItems = async (params) =>
  await api.get("/inventory/recipes/", { params });

export const getProductRecipe = async (productId) =>
  await api.get(`/inventory/products/${productId}/recipe/`);

export const updateProductRecipe = async (productId, data) =>
  await api.put(`/inventory/products/${productId}/recipe/`, data, {
    headers: { "Content-Type": "application/json" },
  });

export const getProductCost = async (productId) =>
  await api.get(`/inventory/products/${productId}/cost/`);

const InventoryService = {
  getIngredients,
  createIngredient,
  updateIngredient,
  deleteIngredient,
  getLowStockIngredients,
  getStockMovements,
  createStockEntry,
  createStockAdjustment,
  getStockSummary,
  getRecipeItems,
  getProductRecipe,
  updateProductRecipe,
  getProductCost,
};

export default InventoryService;
